import { PolicyActionTypes, PaymentActionTypes } from "./types";
import { PaymentAction } from "./payment.actions";
import {PartialPolicy, Policy} from "../../models/policy.model";
import { policyService } from "../../services/policy.service";
import { paymentService } from "../../services/payment.service";
import { Dispatch } from "redux";
import { IPolicyResponse } from "../../models/policy-response.interface";
import { IUtm } from "../../models/utm.interface";

export interface PolicyAction {
  type: PolicyActionTypes;
  payload: IPolicyResponse | null;
}

export const policyActions = {
  createPolicy: (partialPolicy: PartialPolicy, utm: IUtm) => {
    return async (dispatch: Dispatch) => {

      dispatch<PolicyAction>({
        type: PolicyActionTypes.CREATE_POLICY,
        payload: null
      });

      

        await policyService.createPolicy(partialPolicy, utm).then(response => {
          
         // console.log("Response from policyService.createPolicy", response);
          
          dispatch<PolicyAction>({
            type: PolicyActionTypes.CREATE_POLICY_COMPLETED,
            payload: response.data
          });

          
        

        }, error => {
         // console.log(error);
         // console.log("Error from policyService.createPolicy", error);

          dispatch<PolicyAction>({
            type: PolicyActionTypes.CREATE_POLICY_FAILED,
            payload: null
          });
        });
      
    };
  },

  finalisePolicy: (id: number | null, policy: Policy, utm: IUtm) => {
    return async (dispatch: Dispatch) => {

      dispatch<PolicyAction>({
        type: PolicyActionTypes.FINALISE_POLICY,
        payload: null
      });

      if (id == null) {

        await policyService.createPolicy(policy, utm).then(response => {
          //console.log("Response from policyService.finalisePolicy", response);

          dispatch<PolicyAction>({
            type: PolicyActionTypes.CREATE_POLICY_COMPLETED,
            payload: response.data
          });

          paymentService.initiatePayment(response.data.id).then(response => {
            dispatch<PaymentAction>({
              type: PaymentActionTypes.PAYMENT_PROCESS_STARTED,
              payload: response.data
            });
          }, error => {
            //console.log("Error from policyService.finalisePolicy", error);

            dispatch<PaymentAction>({
              type: PaymentActionTypes.PAYMENT_PROCESS_FAILED,
              payload: null
            });
          });


        }, error => {
          // console.log(error);
          dispatch<PolicyAction>({
            type: PolicyActionTypes.CREATE_POLICY_FAILED,
            payload: null
          });
        });
      } else {
        policy.id = id;

        await policyService.finalisePolicy(policy, utm).then(response => {
          //console.log("Response from policyService.finalisePolicy", response);

          dispatch<PolicyAction>({
            type: PolicyActionTypes.FINALISE_POLICY_COMPLETED,
            payload: response.data
          });

          paymentService.initiatePayment(response.data.id).then(response => {
            dispatch<PaymentAction>({
              type: PaymentActionTypes.PAYMENT_PROCESS_STARTED,
              payload: response.data
            });
          }, error => {
            //console.log("Error from policyService.finalisePolicy", error);

            dispatch<PaymentAction>({
              type: PaymentActionTypes.PAYMENT_PROCESS_FAILED,
              payload: null
            });
          });


        }, error => {
          // console.log(error);
          dispatch<PolicyAction>({
            type: PolicyActionTypes.FINALISE_POLICY_FAILED,
            payload: null
          });
        });
      }
    };
  }
};
